import React from 'react';
import { string, bool } from 'prop-types';
import { ProductInfoItem } from './ProductInfoItem';

export const ProductInfo = ({
  itemId, upc, modelNumber, rentalCategory, rentalSubcategory
}) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-2 sui-my-4" data-testid="productInfo">
      <ProductInfoItem title="Product ID" info={itemId} />
      { upc && (<ProductInfoItem title="Internet" info={upc} />)}
      { modelNumber && (<ProductInfoItem title="Model" info={modelNumber} />)}
      { rentalCategory && (<ProductInfoItem title="Rental Category" info={rentalCategory} />)}
      { rentalSubcategory && (<ProductInfoItem title="Rental Subcategory" info={rentalSubcategory} />)}
    </div>
  );
};

ProductInfo.displayName = 'ProductInfo';

ProductInfo.propTypes = {
  itemId: string.isRequired,
  upc: string,
  modelNumber: string,
  rentalCategory: string,
  rentalSubcategory: string
};

ProductInfo.defaultProps = {
  upc: '',
  modelNumber: '',
  rentalCategory: '',
  rentalSubcategory: ''
};
